<template>
  <FilterDropdown :options="options" @select:change="onChange" />
</template>

<script lang="ts">
import type { SelectOptions } from '@/types/Components/SelectOptions'
import { defineComponent } from 'vue'
import { ASSIGNMENT_TYPE } from '@/const/AssignmentListQueryFilters'
import { CONSOLIDATE, RETURN, SINGLE } from '@/const/AssignmentTypes'
import { useAssignmentStore } from '@/store/assignment'
import FilterDropdown from '@/views/Components/PageParts/FilterDropdown.vue'

export default defineComponent({
  name: 'TypeFilter',
  components: { FilterDropdown },
  setup() {
    const assignmentStore = useAssignmentStore()

    const options: SelectOptions[] = [
      { value: '', text: 'Type' },
      { value: SINGLE, text: 'Single-item' },
      { value: CONSOLIDATE, text: 'Batch' },
      { value: RETURN, text: 'Return' },
    ]
    const onChange = (value: string) => {
      assignmentStore.updateFilterValue({ key: ASSIGNMENT_TYPE, value })
    }

    return {
      onChange,
      options,
    }
  },
})
</script>
